<template>
    <div class="error-container">
        <div class="error-content">
            <slot name="error-image"></slot>
            <div class="error-text-wrap">
                <p class="error-big-text h2">{{ props.errorTitle }}</p>
                <p class="error-text body-3--regular">{{ props.errorDescription }}</p>
                <!-- <button class="retry-button body-3" @click="retryLoadData">다시 시도</button> -->
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{
    errorDescription: string;
    errorTitle: string;
}>();
</script>

<style scoped lang="scss">
.error-container {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: white;
}

.error-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem;
    border-radius: 1rem;

    .error-image {
        width: 70%;
        height: 70%;
        margin-bottom: 1.5rem;
    }

    .error-text-wrap {
        text-align: center;

        .error-big-text {
            color: $grey-7;
            margin-bottom: 0.5rem;
        }

        .error-text {
            color: $grey-7;
            margin-bottom: 1.5rem;
            white-space: pre-line;
        }

        .retry-button {
            background: $pro-secondary-blue;
            color: $primary-white;
            padding: 0.8rem 1.5rem;
            border-radius: 0.8rem;
            border: none;
            cursor: pointer;
            transition: background-color 0.2s ease;

            &:hover {
                background: $pro-secondary-blue;
            }
        }
    }
}
</style>
